import * as React from 'react'

import { GlobalCountDownAndDateType } from '@thg-commerce/enterprise-widgets/src/DispatchAndDateCountdownWidgetRenderer'

import {
  DateCountdownStyledContainer,
  Separator,
  StyledTimeCountdown,
  StyledWidgetCountdownContainer,
  TimerSpan,
  TitleSpan,
  WidgetCountdownSubTitle,
  WidgetCountdownTitle,
  WidgetTitleContainer,
} from './styles'

export const DispatchAndDateCountdown = (props: GlobalCountDownAndDateType) => {
  return (
    <StyledWidgetCountdownContainer
      textDecoration={props.textDecoration}
      {...(props.linkUrl && { href: props.linkUrl })}
      backgroundColour={props.backgroundColour}
    >
      <WidgetTitleContainer>
        {props.countDownTitle && (
          <WidgetCountdownTitle titleColour={props.titleColour}>
            {props.countDownTitle}
          </WidgetCountdownTitle>
        )}
        {props.countDownSubTitle && (
          <WidgetCountdownSubTitle subtitleColour={props.subtitleColour}>
            {props.countDownSubTitle}
          </WidgetCountdownSubTitle>
        )}
      </WidgetTitleContainer>

      {props.showTimer && (
        <DateCountdownStyledContainer>
          {props.displayWeekTimer && props.weeks && (
            <React.Fragment>
              <StyledTimeCountdown>
                <TimerSpan digitsColour={props.digitsColour}>
                  {props.weeks}
                </TimerSpan>
                <TitleSpan digitsColour={props.subtitleColour}>
                  {props.weeksTitle}
                </TitleSpan>
              </StyledTimeCountdown>
              <Separator separatorColour={props.separatorColour}>
                {props.separator}
              </Separator>
            </React.Fragment>
          )}
          {props.remainingDays && (
            <React.Fragment>
              <StyledTimeCountdown>
                <TimerSpan digitsColour={props.digitsColour}>
                  {props.remainingDays}
                </TimerSpan>
                <TitleSpan digitsColour={props.subtitleColour}>
                  {props.daysTitle}
                </TitleSpan>
              </StyledTimeCountdown>
              <Separator separatorColour={props.separatorColour}>
                {props.separator}
              </Separator>
            </React.Fragment>
          )}
          {props.hours && (
            <React.Fragment>
              <StyledTimeCountdown>
                <TimerSpan digitsColour={props.digitsColour}>
                  {props.hours}
                </TimerSpan>
                <TitleSpan digitsColour={props.subtitleColour}>
                  {props.hoursTitle}
                </TitleSpan>
              </StyledTimeCountdown>
              <Separator separatorColour={props.separatorColour}>
                {props.separator}
              </Separator>
            </React.Fragment>
          )}
          {props.minutes && (
            <React.Fragment>
              <StyledTimeCountdown>
                <TimerSpan digitsColour={props.digitsColour}>
                  {props.minutes}
                </TimerSpan>
                <TitleSpan digitsColour={props.subtitleColour}>
                  {props.minutesTitle}
                </TitleSpan>
              </StyledTimeCountdown>
              <Separator separatorColour={props.separatorColour}>
                {props.separator}
              </Separator>
            </React.Fragment>
          )}
          <StyledTimeCountdown>
            <TimerSpan digitsColour={props.digitsColour}>
              {props.seconds}
            </TimerSpan>
            <TitleSpan digitsColour={props.subtitleColour}>
              {props.secondsTitle}
            </TitleSpan>
          </StyledTimeCountdown>
        </DateCountdownStyledContainer>
      )}
    </StyledWidgetCountdownContainer>
  )
}
